import { currentLang, formatDate } from '@/helpers';
import estateStoreGetters from '@constans/store/estate/estateStoreGetters';
const getters = {
    [estateStoreGetters.CURRENT_STEP]: state => state.current_step,
    [estateStoreGetters.COPY_ADDRESS]: state => state.copyAddress,
    [estateStoreGetters.GET_CREATE_PAYLOAD]: state => state.payload,
    [estateStoreGetters.GET_ESTATE_LIST]: state => state.list,
    [estateStoreGetters.GET_SINGLE_ESTATE]: state => state.single,
    [estateStoreGetters.GET_METHOD]: state => state.method,
    [estateStoreGetters.GET_MAPPED_PROP]: state => (prop) => {
        if (prop) {
            const mappedProps = state.single?.mapped_ids;
            if (mappedProps) {
                const target = mappedProps[prop.key];
                if (target) {
                    if (prop.type === 'checkbox') {
                        if ('id' in prop) {
                            return target.find((item) => item.id === prop.id) !== undefined;
                        }
                        else {
                            const items = target.map((item) => item.property_name.find((l) => l.lang === currentLang)?.value);
                            return items.length > 0 ? items.join(', ') : '';
                        }
                    }
                    if (prop.type === 'select') {
                        const item = target[0].property_name.find((l) => l.lang === currentLang);
                        return item.value;
                    }
                }
            }
        }
        return null;
    },
    [estateStoreGetters.GET_ESTATE_LAST_UPDATED]: state => state.single?.updated_at ? formatDate(state.single?.updated_at) : null,
    // Select props
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_RESIDENCE]: (state) => state.related_prop.ConfigureEstatePropertyResidenceTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_KITCHEN]: (state) => state.related_prop.ConfigureEstatePropertyKitchen,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_BALCONY]: (state) => state.related_prop.ConfigureEstatePropertyBalconyTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_FURNISHING]: (state) => state.related_prop.ConfigureEstatePropertyFurnishingTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_FLOOR]: (state) => state.related_prop.ConfigureEstatePropertyFloorTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_EXTENSION]: (state) => state.related_prop.ConfigureEstatePropertyExtensionTypes,
    // Select props - selected
    [estateStoreGetters.GET_SELECTED_KITCHEN_TYPE]: (state) => state.payload.props_ids['ConfigureEstatePropertyKitchen'] ? state.payload.props_ids['ConfigureEstatePropertyKitchen'][0] : null,
    [estateStoreGetters.GET_SELECTED_RESIDENCE_TYPE]: (state) => state.payload.props_ids['ConfigureEstatePropertyResidenceTypes'] ? state.payload.props_ids['ConfigureEstatePropertyResidenceTypes'][0] : null,
    [estateStoreGetters.GET_SELECTED_BALCONY_TYPE]: (state) => state.payload.props_ids['ConfigureEstatePropertyBalconyTypes'] ? state.payload.props_ids['ConfigureEstatePropertyBalconyTypes'][0] : null,
    [estateStoreGetters.GET_SELECTED_FURNISHING_TYPE]: (state) => state.payload.props_ids['ConfigureEstatePropertyFurnishingTypes'] ? state.payload.props_ids['ConfigureEstatePropertyFurnishingTypes'][0] : null,
    [estateStoreGetters.GET_SELECTED_FLOOR_TYPE]: (state) => state.payload.props_ids['ConfigureEstatePropertyFloorTypes'] ? state.payload.props_ids['ConfigureEstatePropertyFloorTypes'][0] : null,
    [estateStoreGetters.GET_SELECTED_EXTENSION_TYPE]: (state) => state.payload.props_ids['ConfigureEstatePropertyExtensionTypes'] ? state.payload.props_ids['ConfigureEstatePropertyExtensionTypes'][0] : null,
    // Checkbox porps
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_AREA]: (state) => state.related_prop.ConfigureEstatePropertyAreaDescriptionTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_EQUIPMENT]: (state) => state.related_prop.ConfigureEstatePropertyEquipmentTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_INCLUDE_RENT]: (state) => state.related_prop.ConfigureEstatePropertyIncludeRentTypes,
    [estateStoreGetters.GET_CONFIGURE_ESTATE_PROPERTY_REQUISITES]: (state) => state.related_prop.ConfigureEstatePropertyRequisitesTypes,
};
export default getters;
